import { css } from '@emotion/react';
import { AppointmentAggregatesResponse } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { theme } from '@frontend/theme';
import { VIEW_KEYS } from '../constants';
import { useAppointmentAnalyticsV2ShallowStore } from '../hooks/use-appointment-analytics-v2-store';
import { AppointmentBreakdownChart } from './past-appointments/appointment-breakdown-chart';
import { KPICards } from './past-appointments/kpi-cards';
import { NoShowRateChart } from './past-appointments/no-show-rate-chart';
import { TopBanner } from './past-appointments/top-banner';
import { AppointmentAnalyticsV2TableView } from './views/table-view';

interface Props {
  aggregatesData: AppointmentAggregatesResponse | undefined;
  aggregatesDataLoading: boolean;
}
export const PastAppointmentsTab = (props: Props) => {
  const { aggregatesData, aggregatesDataLoading } = props;
  const { view } = useAppointmentAnalyticsV2ShallowStore('view');

  return (
    <div css={styles.tabContent}>
      {view === VIEW_KEYS.TABLE ? (
        <AppointmentAnalyticsV2TableView />
      ) : (
        <>
          <TopBanner aggregatesData={aggregatesData} aggregatesDataLoading={aggregatesDataLoading} />
          <KPICards aggregatesData={aggregatesData} aggregatesDataLoading={aggregatesDataLoading} />
          <AppointmentBreakdownChart aggregatesData={aggregatesData} aggregatesDataLoading={aggregatesDataLoading} />
          <NoShowRateChart />
        </>
      )}
    </div>
  );
};

const styles = {
  tabContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
  `,
};
